import { ApplicationType } from '@sdir/httpclient/lib/clients/aps/application';
import { Step, StepStatus } from '@sdir/sds';
import { IntlShape } from 'react-intl';
import { matchPath } from 'react-router-dom';
import { routes } from '../constants/routes';
import { DEFAULT_LANG } from './languageHelpers';

export type StepDefinition = {
  label: string;
  route: string;
  hideForApplicationType?: ApplicationType[];
};

export type MssStep = Step & {
  route: string;
};

const allApplicationSteps: StepDefinition[] = [
  {
    label: 'newapp.steps.qualifications',
    route: routes.application.qualification,
  },
  {
    label: 'newapp.steps.contactinfo',
    route: routes.application.contactInfo,
  },
  {
    label: 'newapp.steps.summary',
    route: routes.application.summary,
  },
  {
    label: 'newapp.steps.payment',
    route: routes.application.payment,
  },
];

export const getStepsForAppType = (
  appType: ApplicationType,
  isExternalUser: boolean
): StepDefinition[] => {
  return allApplicationSteps.filter((s) => !s.hideForApplicationType?.includes(appType));
};

export const getStepsForSid = (): StepDefinition[] => {
  return allApplicationSteps;
};

export const getPathWithoutLang = (intl: IntlShape, pathname: string) => {
  let path = pathname;
  // Handle language routes
  if (intl.locale !== DEFAULT_LANG && path?.includes(`/${intl.locale}/`)) {
    path = path.replace(`/${intl.locale}/`, '/');
  }
  return path;
};

export const getPrevStep = (
  pathname: string,
  appType: ApplicationType,
  intl: IntlShape,
  isExternalUser: boolean
): StepDefinition | null => {
  const filteredSteps = getStepsForAppType(appType, isExternalUser);
  const path = getPathWithoutLang(intl, pathname);
  const indexOfMatch = filteredSteps.findIndex((s) => matchPath(s.route, path));
  if (indexOfMatch < 0) return null;
  return filteredSteps[indexOfMatch - 1] || null;
};

export const getNextStep = (
  pathname: string,
  appType: ApplicationType,
  intl: IntlShape,
  isExternalUser: boolean
): StepDefinition | null => {
  const filteredSteps = getStepsForAppType(appType, isExternalUser);
  const path = getPathWithoutLang(intl, pathname);
  const indexOfMatch = filteredSteps.findIndex((s) => matchPath(s.route, path));
  if (indexOfMatch < 0) return null;
  return filteredSteps[indexOfMatch + 1] || null;
};

export const getCurrentSteps = (
  pathname: string,
  appType: ApplicationType,
  intl: IntlShape,
  isExternalUser: boolean
): MssStep[] => {
  const filteredSteps = getStepsForAppType(appType, isExternalUser);
  let activeFound = false;
  const path = getPathWithoutLang(intl, pathname);
  return filteredSteps.map((s, i) => {
    let status: StepStatus;
    const matches = matchPath({ path: s.route, end: false }, path);
    if (activeFound) {
      status = StepStatus.DISABLED;
    } else if (matches) {
      status = StepStatus.ACTIVE;
      activeFound = true;
    } else {
      status = StepStatus.DONE;
    }
    return { route: s.route, label: intl.formatMessage({ id: s.label }), value: i + 1, status };
  });
};
